import { FooterLocale, resolveFooterLocale } from 'ComponentLibrary/src/molecules/Footer/footerCopy'
import { getClientPortalBootstrapLocale } from 'ClientPortal/src/consent/clientPortalCcm'

export function getPublicLegalPageLocale(): FooterLocale {
    return resolveFooterLocale(getClientPortalBootstrapLocale())
}
